/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RemoteSessionIssuer,
  RemoteSessionIssuer$inboundSchema,
} from "./remotesessionissuer.js";

/**
 * Outcome of consolidating a tenant remote_session_issuer onto a global issuer: the surviving global issuer, how many clients were re-pointed, and whether the source was soft-deleted.
 */
export type MigrateRemoteSessionIssuerResult = {
  /**
   * Number of remote_session_clients re-pointed from the source issuer to the target issuer. Zero when the source had no active clients.
   */
  clientsMigrated: number;
  /**
   * A remote_session_issuer record — upstream Authorization Server identity that Speakeasy speaks OAuth to.
   */
  issuer: RemoteSessionIssuer;
  /**
   * TRUE when the source issuer was soft-deleted.
   */
  sourceDeleted: boolean;
};

/** @internal */
export const MigrateRemoteSessionIssuerResult$inboundSchema: z.ZodMiniType<
  MigrateRemoteSessionIssuerResult,
  unknown
> = z.pipe(
  z.object({
    clients_migrated: z.int(),
    issuer: RemoteSessionIssuer$inboundSchema,
    source_deleted: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "clients_migrated": "clientsMigrated",
      "source_deleted": "sourceDeleted",
    });
  }),
);

export function migrateRemoteSessionIssuerResultFromJSON(
  jsonString: string,
): SafeParseResult<MigrateRemoteSessionIssuerResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MigrateRemoteSessionIssuerResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MigrateRemoteSessionIssuerResult' from JSON`,
  );
}
